import { cn } from '@/utils/tailwind-util';

import type { TransitionClasses } from './index';

export const MODAL_OVERLAY_TRANSITION: TransitionClasses = {
  enter: 'ease-out duration-300',
  enterFrom: 'opacity-0',
  enterTo: 'opacity-100',
  leave: 'ease-in duration-200',
  leaveFrom: 'opacity-100',
  leaveTo: 'opacity-0',
};

export const MODAL_CONTENT_TRANSITION: TransitionClasses = {
  enter: 'ease-out duration-300',
  enterFrom: 'opacity-0 scale-95',
  enterTo: 'opacity-100 scale-100',
  leave: 'ease-in duration-200',
  leaveFrom: 'opacity-100 scale-100',
  leaveTo: 'opacity-0 scale-95',
};

export const SIDE_MODAL_CONTENT_TRANSITION: TransitionClasses = {
  enter: 'ease-in duration-300',
  enterFrom: 'opacity-95',
  enterTo: 'opacity-100',
  leave: 'ease-out duration-300',
  leaveFrom: 'opacity-100 translate-x-0',
  leaveTo: 'opacity-95 translate-x-full',
};

export const FADE_IN_OUT: TransitionClasses = {
  enter: 'ease-out duration-200',
  enterFrom: 'opacity-0',
  enterTo: 'opacity-100',
  leave: 'ease-in duration-200',
  leaveFrom: 'opacity-100',
  leaveTo: 'opacity-0',
};

export const FADE_IN_OUT_DELAYED: TransitionClasses = {
  enter: 'ease-out duration-700 delay-200',
  enterFrom: 'opacity-0',
  enterTo: 'opacity-100',
  leave: 'ease-in duration-200',
  leaveFrom: 'opacity-100',
  leaveTo: 'opacity-0',
};

export const POPPER_TRANSITION: TransitionClasses = {
  enter: 'transition ease-out duration-200',
  enterFrom: 'opacity-0 translate-y-1',
  enterTo: 'opacity-100 translate-y-0',
  leave: 'transition ease-in duration-150',
  leaveFrom: 'opacity-100 translate-y-0',
  leaveTo: 'opacity-0 translate-y-1',
};
